import { Outlet } from "react-router-dom";
import Footer from "../footer";
import Header from "../header";
import SideBar from "../navigation/sidebar";
import "./layout.css";

function Layout({ children }) {
  return (
    <div className="flex w-full flex-col lg:flex-row min-h-screen">
      <SideBar />
      <div className="layout grow lg:ml-[100px] lg:w-[calc(100%-100px)]">
        <div className="container_xxl grow">
          <Outlet />
          <div className="h-20"></div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Layout;
